<div
  class="iris-checkbox"
  [ngClass]="{'disabled': control.disabled}"
>
  <div
    class="iris-checkbox-highlight-circle"
    [ngClass]="{'show-highlight': isHighlightCircleVisible}"
  >
  </div>
  <div
    class="iris-checkbox-box"
    [ngClass]="{
      'is-checked': control.value,
      'is-highlighted': isHighlightCircleVisible,
      'is-indeterminate': indeterminate
    }"
  >
    <input
      type="checkbox"
      [attr.aria-describedby]="formControlName
        && !subFormControl
        && (control.touched | isControlInvalidAndTouched:control.invalid)
          ? formControlName + '-error-messages' : null"
      [attr.aria-invalid]="control.touched | isControlInvalidAndTouched:control.invalid"
      [attr.required]="(control | isControlRequired) || null"
      [id]="id"
      [formControl]="control"
      (blur)="onBlur()"
      (focus)="onFocus()"
      (mouseenter)="onHoverEnter()"
      (mouseleave)="onHoverLeave()"
      [attr.indeterminate]="indeterminate ? 'true' : null"
    >
    <div
      class="iris-checkmark"
      (mouseenter)="onHoverEnter()"
    >
      <div class="iris-checkmark-right iris-checkmark-half"></div>
      <div class="iris-checkmark-left iris-checkmark-half"></div>
    </div>
    <div class="iris-indeterminate"></div>
  </div>
  <label [for]="id">
    <ng-content></ng-content>
  </label>
</div>
